import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Joyride from "react-joyride";
import DashboardApi from "../../../services/api/dashboardApi";
import { useUser } from "../../../context/userContext";

const TourGuide = () => {
  const [run, setRun] = useState(false);
  const { user, fetchUserInfo } = useUser();
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const tourSteps = [
    // {
    //   target: "#establishment",
    //   content: (
    //     <div>
    //       <h4 style={{ color: "var(--text)" }}>{t("step_1_title")}</h4>
    //       <p style={{ color: "var(--text2)" }}>{t("step_1_description")}</p>
    //     </div>
    //   ),
    //   disableBeacon: true,
    //   placement: language === "en" ? "right" : "left",
    // },
    {
      target: "#org_structure",
      content: (
        <div>
          <h4 style={{ color: "var(--text)" }}>{t("step_2_title")}</h4>
          <p style={{ color: "var(--text2)" }}>{t("step_2_description")}</p>
        </div>
      ),
      disableBeacon: true,
      placement: language === "en" ? "right" : "left",
    },
    {
      target: "#admin_director",
      content: (
        <div>
          <h4 style={{ color: "var(--text)" }}>{t("step_3_title")}</h4>
          <p style={{ color: "var(--text2)" }}>{t("step_3_description")}</p>
        </div>
      ),
      disableBeacon: true,
      placement: language === "en" ? "right" : "left",
    },
    {
      target: "#cabinets",
      content: (
        <div>
          <h4 style={{ color: "var(--text)" }}>{t("step_5_title")}</h4>
          <p style={{ color: "var(--text2)" }}>{t("step_5_description")}</p>
        </div>
      ),
      disableBeacon: true,
      placement: language === "en" ? "right" : "left",
    },
    {
      target: "#users",
      content: (
        <div>
          <h4 style={{ color: "var(--text)" }}>{t("step_4_title")}</h4>
          <p style={{ color: "var(--text2)" }}>{t("step_4_description")}</p>
        </div>
      ),
      disableBeacon: true,
      placement: language === "en" ? "right" : "left",
    },
  ];

  useEffect(() => {
    if (user && !user?.onboarding_shown) {
      setRun(true);
    }
  }, [user]);

  const updateOnboardingStatus = async () => {
    try {
      const { code } = await DashboardApi.getOnboardingStatus();
      if (code === 200) {
        fetchUserInfo();
      }
    } catch (error) {}
  };

  const handleCallback = async (data) => {
    const { status } = data;
    const finishedStatuses = ["finished", "skipped"];
    if (finishedStatuses.includes(status)) {
      await updateOnboardingStatus();
      setRun(false);

      // Remove side effects of Joyride
      document.body.style.overflow = "auto";
      document.body.style.position = "";
    }
  };

  return (
    <Joyride
      steps={tourSteps}
      run={run}
      continuous
      scrollToFirstStep={true}
      spotlightPadding={10}
      showSkipButton
      callback={handleCallback}
      disableScrolling={false}
      disableScrollParentFix={true}
      styles={{
        options: {
          primaryColor: "#0d6efd",
          zIndex: 9999,
        },
        buttonNext: { boxShadow: "none", outline: "none" },
        buttonBack: { boxShadow: "none", outline: "none" },
        buttonSkip: { boxShadow: "none", outline: "none" },
      }}
      locale={{
        last: t("finish"),
        skip: t("skip"),
        next: t("next"),
        back: t("back"),
      }}
    />
  );
};

export default TourGuide;
